import BlockSettings from "./BlockSettings";
import ButtonSettings from "./ButtonSettings";
import CellSettings from "./CellSettings";
import DividerSettings from "./DividerSettings";
import ImageSettings from "./ImageSettings";
import MapSettings from "./MapSettings";
import OrganizationSettings from "./OrganizationSettings";
import SectionSettings from "./SectionSettings";
import SocialSettings from "./SocialSettings";
import TableSettings from "./TableSettings";
import SpacerSettings from "./SpacerSettings";
import UnsubscribleSettings from "./UnsubscribleSettings";
import VideoSettings from "./VideoSettings";
import HtmlSettings from "./HtmlSettings";

export default {
  BlockSettings,
  ButtonSettings,
  CellSettings,
  DividerSettings,
  ImageSettings,
  MapSettings,
  OrganizationSettings,
  SectionSettings,
  SocialSettings,
  SpacerSettings,
  TableSettings,
  UnsubscribleSettings,
  VideoSettings,
  HtmlSettings
};
